import { Clinic, ClinicResponse } from "services/types/clinics.type";

export const getClinicDate = (params: {
  clinic: Clinic | undefined | null;
  date?: Date | null;
  clearTime?: boolean;
}) => {
  const { clinic, date, clearTime } = params;
  if (!clinic?.timezone) return null;

  const result = new Date(
    (date ?? new Date()).toLocaleString("en-US", { timeZone: clinic?.timezone })
  );

  if (clearTime) {
    result.setHours(0);
    result.setMinutes(0);
    result.setMilliseconds(0);
  }

  return result;
};

export const formatClinic = (clinic: ClinicResponse) => {
  const { tilled_account_id, justifi_account_id, practice, ...clinicAttrs } =
    clinic || {};
  return {
    tilledAccountId: tilled_account_id,
    justifiAccountId: justifi_account_id || practice?.justifi_account_id,
    practice,
    ...clinicAttrs,
    fullName: `${clinic?.practice?.name ?? ""} ${clinic?.name ?? ""}`.trim()
  };
};

export const getSelectedClinicIds = (
  selectedClinicIds?: string[] | number[] | null
) => {
  if (Array.isArray(selectedClinicIds) && selectedClinicIds.length) {
    return selectedClinicIds.map((clinicId) => Number(clinicId));
  }
  return undefined;
};

export const determineClinicFiltering = ({
  currentRegionClinicsIds,
  currentClinic,
  includeOtherClinics,
  isShowOwnClinicsOnlyEnabled,
  userClinicsIds
}: {
  currentClinic: Clinic | undefined;
  includeOtherClinics: boolean;
  currentRegionClinicsIds?: number[];
  isShowOwnClinicsOnlyEnabled?: boolean;
  userClinicsIds?: number[];
}) => {
  if (includeOtherClinics) {
    return isShowOwnClinicsOnlyEnabled
      ? userClinicsIds?.length
        ? userClinicsIds
        : currentClinic?.id
      : currentRegionClinicsIds;
  }

  return currentClinic?.id ?? undefined;
};
